/**
 *
 * @param text
 * @param matches {Array[Object]} = { key: string, parse: boolean }
 * @returns {{}}
 */
function parseGptResponse(text, matches) {
  const blocks = {};
  blocks.raw = text;

  const makeRegex = (prefixStr) => {
    // Create a dynamic regular expression for the prefix
    return new RegExp("```" + prefixStr + "\\n([\\s\\S]*?)```", "g");
  };

  // Copy of the original text to remove matched parts from
  let remainderText = text;

  matches.forEach(match => {
    const { key, parse } = match;
    const regex = makeRegex(key);
    const matchedResult = regex.exec(text); // Use exec() to capture groups

    if (matchedResult) {
      const result = matchedResult[1]; // Group 1 will contain the code block
      try {
        blocks[key] = parse ? JSON.parse(result) : result; // Parse or store the result
      } catch (e) {
        console.error(`Failed to parse block for key ${key}:`, e);
      }

      // Remove matched result from the remainder text
      remainderText = remainderText.replace(matchedResult[0], '');
    }
  });

  // Trim and store remaining unmatched text in the 'remainder' field
  blocks.remainder = remainderText.trim();

  return blocks;
}

export {
  parseGptResponse
};
